module.exports = __webpack_public_path__ + "media/images/illustrations/nanny-93a5cdf4884a626157e1569f300f36f1.svg";